import { COLORS } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 5.625rem;
  height: 1.5rem;
  border-radius: 1.6rem;
  background: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
  color: ${COLORS.WHITE};
`;

export const StyledActionButton = styled(Button)<{ $color?: string; $width?: string }>`
  &&& {
    background: ${({ $color = COLORS.PALE_YELLOW }) => $color};
    padding: 0.25rem;
    border: none;
    width: ${({ $width = '2.125rem' }) => $width};
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;
